import { Trans } from "@lingui/macro";
import { ReactElement } from "react";

export interface Position {
  label: ReactElement;
  title: Object;
  seoDescription: Object;
  heroImage: string;
  heroImageLarge?: string;
  seoImage: string;
  position: string;
  categories: any[];
  role: any;
  todos: ReactElement;
  nonTechRequirement?: ReactElement;
  requirement: ReactElement;
  team: ReactElement;
  application: ReactElement;
}

export const positionAvailable: Position[] = [
  // {
  //   label: <Trans>Product</Trans>,
  //   title: {
  //     en: "Product Manager",
  //     ms: "Product Manager",
  //     zh: "Product Manager",
  //   },
  //   seoDescription: {
  //     en: "Lead the development of innovative features, manage the product roadmap, and ensure that Lumi News remains competitive in the ever-evolving news ecosystem. ",
  //     ms: "Lead the development of innovative features, manage the product roadmap, and ensure that Lumi News remains competitive in the ever-evolving news ecosystem. ",
  //     zh: "Lead the development of innovative features, manage the product roadmap, and ensure that Lumi News remains competitive in the ever-evolving news ecosystem. ",
  //   },
  //   heroImage: "/subdomain/jobpost/marketing-lead-cover.jpg",
  //   heroImageLarge: "/subdomain/jobpost/marketing-lead-cover-large.jpg",
  //   seoImage: "/subdomain/jobpost/marketing-lead-cover-seo.png",
  //   position: "Product-Manager",
  //   categories: [
  //     {
  //       key: "product",
  //       name: <Trans>📱 Product</Trans>,
  //     },
  //     {
  //       key: "workHours",
  //       name: <Trans>🕦 Full-time</Trans>,
  //     },
  //     // {
  //     //   key: "salary",
  //     //   name: <Trans>🎓 Fresh grads may apply</Trans>,
  //     // },
  //   ],
  //   role: {
  //     emoji: "🚀",
  //     position: <Trans>Product Manager</Trans>,
  //     salary: <Trans>Open for discussion based on working experience</Trans>,
  //     location: <Trans>KL Eco City, Kuala Lumpur</Trans>,
  //     workinghours: (
  //       <Trans>Mondays-Wednesday (office); Thursdays-Fridays (remote)</Trans>
  //     ),
  //   },
  //   todos: (
  //     <>
  //       <p>
  //         <Trans>
  //           Lead the development of innovative features, manage the product
  //           roadmap, and ensure that Lumi News remains competitive in the
  //           ever-evolving news ecosystem.
  //         </Trans>
  //       </p>
  //       <br />
  //       <h3 className="mb-2 text-xl font-bold">
  //         Product development and management
  //       </h3>
  //       <ul className="mb-4 list-inside list-disc">
  //         <li>
  //           <Trans>
  //             Lead the conceptualisation, development, and launch of new app
  //             features
  //           </Trans>
  //         </li>
  //         <li>
  //           <Trans>Maintain and optimize existing product offerings</Trans>
  //         </li>
  //         <li>
  //           <Trans>Create and manage a comprehensive product roadmap</Trans>
  //         </li>
  //         <li>
  //           <Trans>
  //             Conduct regular user research to inform product decisions
  //           </Trans>
  //         </li>
  //         <li>
  //           <Trans>
  //             Analyse user data and feedback to drive product improvements
  //           </Trans>
  //         </li>
  //       </ul>
  //       <h3 className="mb-2 text-xl font-bold">Engineering collaboration</h3>
  //       <ul className="mb-4 list-inside list-disc">
  //         <li>
  //           <Trans>
  //             Work closely with the engineering team to define technical
  //             requirements
  //           </Trans>
  //         </li>
  //         <li>
  //           <Trans>Prioritise and manage bug fixes and technical debt</Trans>
  //         </li>
  //         <li>
  //           <Trans>
  //             Ensure smooth communication between product and engineering teams
  //           </Trans>
  //         </li>
  //       </ul>
  //       <h3 className="mb-2 text-xl font-bold">Project management</h3>
  //       <ul className="mb-4 list-inside list-disc">
  //         <li>
  //           <Trans>
  //             Oversee the product development lifecycle from ideation to launch
  //           </Trans>
  //         </li>
  //         <li>
  //           <Trans>
  //             Manage timelines and resources to ensure on-time delivery of
  //             features
  //           </Trans>
  //         </li>
  //         <li>
  //           <Trans>
  //             Coordinate cross-functional teams to align on product goals and
  //             timelines
  //           </Trans>
  //         </li>
  //       </ul>
  //       <h3 className="mb-2 text-xl font-bold">Market analysis and strategy</h3>
  //       <ul className="list-inside list-disc">
  //         <li>
  //           <Trans>
  //             Stay updated on the Malaysian news ecosystem and global trends
  //           </Trans>
  //         </li>
  //         <li>
  //           <Trans>
  //             Conduct competitor analysis to identify opportunities and threats
  //           </Trans>
  //         </li>
  //         <li>
  //           <Trans>
  //             Propose strategic initiatives to maintain Lumi's market position
  //           </Trans>
  //         </li>
  //         <li>
  //           <Trans>
  //             Explore innovative ways to present news within the app
  //           </Trans>
  //         </li>
  //       </ul>
  //     </>
  //   ),
  //   requirement: (
  //     <>
  //       <ul className="mb-4 list-disc">
  //         <li>
  //           <Trans>
  //             At least 1 year of experience in product management, preferably in
  //             mobile apps or digital media
  //           </Trans>
  //         </li>
  //         <li>
  //           <Trans>
  //             Proven track record of successfully launching and scaling digital
  //             products
  //           </Trans>
  //         </li>
  //       </ul>
  //       <h3 className="mb-2 text-xl font-bold">Technical skills</h3>
  //       <ul className="mb-4 list-inside list-disc">
  //         <li>
  //           <Trans>
  //             Strong understanding of mobile app development processes
  //           </Trans>
  //         </li>
  //         <li>
  //           <Trans>Familiarity with agile methodologies</Trans>
  //         </li>
  //         <li>
  //           <Trans>
  //             Proficiency in data analysis and product analytics tools
  //           </Trans>
  //         </li>
  //         <li>
  //           <Trans>Basic understanding of UI/UX principles</Trans>
  //         </li>
  //       </ul>
  //       <h3 className="mb-2 text-xl font-bold">Soft skills</h3>
  //       <ul className="mb-4 list-inside list-disc">
  //         <li>
  //           <Trans>
  //             Excellent communication and interpersonal skills - people love
  //             working with you!
  //           </Trans>
  //         </li>
  //         <li>
  //           <Trans>Strong leadership and team management abilities</Trans>
  //         </li>
  //         <li>
  //           <Trans>Creative problem-solving and strategic thinking</Trans>
  //         </li>
  //         <li>
  //           <Trans>
  //             Ability to work effectively in a fast-paced, startup environment
  //           </Trans>
  //         </li>
  //       </ul>
  //       <h3 className="mb-2 text-xl font-bold">Industry knowledge</h3>
  //       <ul className=" list-inside list-disc">
  //         <li>
  //           <Trans>
  //             Understanding of the digital news landscape in Malaysia
  //           </Trans>
  //         </li>
  //         <li>
  //           <Trans>Passion for news and current affairs</Trans>
  //         </li>
  //         <li>
  //           <Trans>
  //             Awareness of global trends in news consumption and aggregation
  //           </Trans>
  //         </li>
  //         <li>
  //           <Trans>
  //             Fluency in English and Bahasa Malaysia; knowledge of other local
  //             languages is a plus
  //           </Trans>
  //         </li>
  //         <li>
  //           <Trans>
  //             Experience with A/B testing and user research methodologies
  //           </Trans>
  //         </li>
  //       </ul>
  //     </>
  //   ),
  //   team: null,
  //   //   <ul className="list-disc">
  //   //     <li>
  //   //       <Trans>
  //   //         You’ll be working with the content, design, and tech teams in Lumi
  //   //         in the planning of campaigns and production of marketing materials
  //   //         to align growth initiatives with overall company goals.
  //   //       </Trans>
  //   //     </li>
  //   //     <li>
  //   //       <Trans>
  //   //         You’ll also be striking new partnership opportunities by approaching
  //   //         brands, media agencies, creative agencies, PR firms, personalities,
  //   //         and ministries to grow Lumi revenue streams.
  //   //       </Trans>
  //   //     </li>
  //   //   </ul>
  //   // ),
  //   application: (
  //     <Trans>
  //       <p className="font-sen">
  //         Email your CV and writing samples to&nbsp;
  //         <a href="mailto: work@luminews.my" className="text-primary underline">
  //           work@luminews.my&nbsp;
  //         </a>
  //         and tell us why we should hire you!
  //       </p>
  //     </Trans>
  //   ),
  // },
  // {
  //   label: <Trans>Marketing</Trans>,
  //   title: {
  //     en: "Growth Marketing Strategist",
  //     ms: "Growth Marketing Strategist",
  //     zh: "增长营销策略师",
  //   },
  //   seoDescription: {
  //     en: "You will oversee user acquisition, strategy, partnerships, and multi-channel marketing for Lumi News.",
  //     ms: "Anda akan mengawasi pemerolehan pengguna, strategi, perkongsian dan pemasaran berbilang saluran untuk Lumi News.",
  //     zh: "您将负责监督 Lumi News 的用户获取、战略、合作伙伴关系和多渠道营销。",
  //   },
  //   heroImage: "/subdomain/jobpost/marketing-lead-cover.jpg",
  //   heroImageLarge: "/subdomain/jobpost/marketing-lead-cover-large.jpg",
  //   seoImage: "/subdomain/jobpost/marketing-lead-cover-seo.png",
  //   position: "Growth-Marketing-Strategist",
  //   categories: [
  //     {
  //       key: "content",
  //       name: <Trans>📇 Marketing</Trans>,
  //     },
  //     {
  //       key: "workHours",
  //       name: <Trans>🕦 Full-time</Trans>,
  //     },
  //     // {
  //     //   key: "salary",
  //     //   name: <Trans>🎓 Fresh grads may apply</Trans>,
  //     // },
  //   ],
  //   role: {
  //     emoji: "📇",
  //     position: <Trans>Growth Marketing Strategist</Trans>,
  //     salary: <Trans>Open for discussion based on working experience</Trans>,
  //     location: <Trans>KL Eco City, Kuala Lumpur</Trans>,
  //     workinghours: (
  //       <Trans>Mondays-Wednesday (office); Thursdays-Fridays (remote)</Trans>
  //     ),
  //   },
  //   todos: (
  //     <>
  //       <p>
  //         <Trans>
  //           You will oversee user acquisition, strategy, partnerships, and
  //           multi-channel marketing for Lumi News.
  //         </Trans>
  //       </p>
  //       <br />
  //       <ul className="list-disc">
  //         <li>
  //           <Trans>
  //             Manage and run all paid channels, and provide strategic decisions
  //             on budget management to achieve maximum ROI.
  //           </Trans>
  //         </li>
  //         <li>
  //           <Trans>
  //             Develop high-impact campaigns that drive brand awareness, user
  //             acquisition, and revenue growth with the help of marketing
  //             automation tools.
  //           </Trans>
  //         </li>
  //         <li>
  //           <Trans>
  //             Spearhead experimentation initiatives to test new growth
  //             strategies, which may include paid ads, SEO, app/website features,
  //             organic collaborations and content marketing, and identify
  //             successful methods to ensure scalable initiatives.
  //           </Trans>
  //         </li>
  //         <li>
  //           <Trans>
  //             Collaborate with cross-functional teams: product, content, design,
  //             and tech, in the planning of campaigns and production of marketing
  //             materials to align growth initiatives with overall company goals.
  //           </Trans>
  //         </li>
  //         <li>
  //           <Trans>
  //             Finding and managing new partnership opportunities by approaching
  //             brands, media agencies, creative agencies, PR firms, and
  //             ministries to grow Lumi revenue streams.
  //           </Trans>
  //         </li>
  //       </ul>
  //     </>
  //   ),
  //   requirement: (
  //     <ul className="list-disc">
  //       <li>
  //         <Trans>
  //           You possess a metrics and results-driven marketing mind with an eye
  //           for creativity (we love memes and localised lingo!).
  //         </Trans>
  //       </li>
  //       <li>
  //         <Trans>
  //           You must be able to work independently, resourcefully, and
  //           collaboratively.
  //         </Trans>
  //       </li>
  //       <li>
  //         <Trans>
  //           You're curious, competitive, and willing to take calculated risks to
  //           drive new ideas and overcome challenges. You're not afraid to make
  //           the first move!
  //         </Trans>
  //       </li>
  //       <li>
  //         <Trans>
  //           Solid project management skills: you can lead and collaborate with
  //           cross-functional partners, prioritise high impact activities, and
  //           keep projects moving at all times. You're a people person who stays
  //           on top of things.
  //         </Trans>
  //       </li>
  //       <li>
  //         <Trans>
  //           Strong growth track record, with samples of past campaigns that
  //           display growth marketing & A/B testing skills (tell us about it in
  //           your application!)
  //         </Trans>
  //       </li>
  //       <li>
  //         <Trans>
  //           Knowledge of Google Analytics, app attribution tools, social media
  //           analytics, and tools that would help in optimising marketing
  //           efforts.
  //         </Trans>
  //       </li>
  //       <li>
  //         <Trans>
  //           Absolutely fluent in written and spoken English (fluency in BM and
  //           Chinese would be a plus).
  //         </Trans>
  //       </li>
  //       <li>
  //         <Trans>
  //           Experience in media, a startup or a fast-paced work environment
  //           would be great!
  //         </Trans>
  //       </li>
  //     </ul>
  //   ),
  //   team: (
  //     <ul className="list-disc">
  //       <li>
  //         <Trans>
  //           You’ll be working with the content, design, and tech teams in Lumi
  //           in the planning of campaigns and production of marketing materials
  //           to align growth initiatives with overall company goals.
  //         </Trans>
  //       </li>
  //       <li>
  //         <Trans>
  //           You’ll also be striking new partnership opportunities by approaching
  //           brands, media agencies, creative agencies, PR firms, personalities,
  //           and ministries to grow Lumi revenue streams.
  //         </Trans>
  //       </li>
  //     </ul>
  //   ),
  //   application: (
  //     <Trans>
  //       <p className="font-sen">
  //         Email your CV and writing samples to&nbsp;
  //         <a href="mailto: work@luminews.my" className="text-primary underline">
  //           work@luminews.my&nbsp;
  //         </a>
  //         and tell us why we should hire you!
  //       </p>
  //     </Trans>
  //   ),
  // },
  // {
  //   label: <Trans>Content</Trans>,
  //   title: {
  //     en: "Content Intern",
  //     ms: "Content Intern",
  //     zh: "内容实习生",
  //   },
  //   seoDescription: {
  //     en: "Join our content team in cultivating a vibrant news reading habit among Malaysians.",
  //     ms: "Sertai pasukan kandungan kami dalam memupuk tabiat membaca berita yang rancak di kalangan rakyat Malaysia.",
  //     zh: "加入我们的内容团队，在人群中培养充满活力的新闻阅读习惯。",
  //   },
  //   heroImage: "/subdomain/jobpost/content-hero-2.jpeg",
  //   seoImage: "/subdomain/jobpost/content-hero-2.jpeg",
  //   position: "Content-Intern",
  //   categories: [
  //     {
  //       key: "content",
  //       name: <Trans>📇 Content</Trans>,
  //     },
  //     {
  //       key: "internship",
  //       name: <Trans>🕦 Internship</Trans>,
  //     },
  //     {
  //       key: "freelancer",
  //       name: <Trans>⭐ Freelancers may apply</Trans>,
  //     },
  //   ],
  //   role: {
  //     emoji: "📇",
  //     position: <Trans>Content Intern (GE15 & Trending News)</Trans>,
  //     salary: <Trans>RM650 a month</Trans>,
  //     location: <Trans>Bangsar, Kuala Lumpur</Trans>,
  //     workinghours: (
  //       <Trans>Mondays-Wednesday (office); Thursdays-Fridays (remote)</Trans>
  //     ),
  //   },
  //   todos: (
  //     <>
  //       <p>
  //         <Trans>
  //           Grow the readership of Lumi News by managing app content for
  //           Malaysians who are curious and hungry for news! Become one of our
  //           Content Admins 😎
  //         </Trans>
  //       </p>
  //       <br />
  //       <ul className="list-disc">
  //         <li>
  //           <Trans>
  //             Manage News Stacks: compile, update, and create compilations of
  //             links and resources on Malaysia's hot topics.
  //           </Trans>
  //         </li>
  //         <li>
  //           <Trans>
  //             Push notification management: Write and send hyper-local push
  //             notifications to Lumi News users.
  //           </Trans>
  //         </li>
  //         <li>
  //           <Trans>
  //             Monitor the web for important news of the day and select which
  //             ones get posted on Lumi's social media channels.
  //           </Trans>
  //         </li>
  //         <li>
  //           <Trans>Assist the team with Community and Support tasks.</Trans>
  //         </li>
  //         <li>
  //           <Trans>
  //             Assist in copywriting tasks in English (and BM/Chinese if
  //             possible).
  //           </Trans>
  //         </li>
  //         <li>
  //           <Trans>
  //             Social media content management: create engaging and informative
  //             social media content for Lumi News followers.
  //           </Trans>
  //         </li>
  //         <li>
  //           <Trans>
  //             Any other content-related tasks that will add value to Lumi's
  //             growth targets.
  //           </Trans>
  //         </li>
  //       </ul>
  //     </>
  //   ),
  //   requirement: (
  //     <ul className="list-disc">
  //       <li>
  //         <Trans>
  //           Join us for at least 3 months! Part-timers/freelancers are welcome
  //           too.
  //         </Trans>
  //       </li>
  //       <li>
  //         <Trans>
  //           Journalistic and/or writing background in English with a keen
  //           interest in news and current issues.
  //         </Trans>
  //       </li>
  //       <li>
  //         <Trans>Strong news and editorial judgment.</Trans>
  //       </li>
  //       <li>
  //         <Trans>
  //           Willing to be on standby at night or over the weekend as and when
  //           there's breaking news.
  //         </Trans>
  //       </li>
  //       <li>
  //         <Trans>Social media savvy.</Trans>
  //       </li>
  //       <li>
  //         <Trans>
  //           The ability to read and write in either BM or Chinese in addition to
  //           English, would be a plus.
  //         </Trans>
  //       </li>
  //       <li>
  //         <Trans>
  //           Must be organised, able to multitask; fast and detailed.
  //         </Trans>
  //       </li>
  //       <li>
  //         <Trans>
  //           Great if you have an eye for good graphic design and know how to use
  //           Photoshop/Illustrator.
  //         </Trans>
  //       </li>
  //     </ul>
  //   ),
  //   team: (
  //     <ul className="list-disc">
  //       <li>
  //         <Trans>You'll be part of Lumi's Content Team!</Trans>
  //       </li>
  //       <li>
  //         <Trans>
  //           You'll also be collaborating with our Product Manager & Growth
  //           Marketing Manager on copywriting tasks and strategising the best
  //           angles for content marketing campaigns.
  //         </Trans>
  //       </li>
  //     </ul>
  //   ),
  //   application: (
  //     <Trans>
  //       <p className="font-sen">
  //         Email your CV and writing samples to&nbsp;
  //         <a href="mailto: work@luminews.my" className="text-primary underline">
  //           work@luminews.my&nbsp;
  //         </a>
  //         and tell us why we should hire you!
  //       </p>
  //     </Trans>
  //   ),
  // },
  // {
  //   label: <Trans>Tech</Trans>,
  //   title: {
  //     en: "Flutter App Developer",
  //     ms: "Pembangun Aplikasi Flutter",
  //     zh: "Flutter App Developer",
  //   },
  //   seoDescription: {
  //     en: "Join our tech team to grow the Lumi News app for millions of Malaysians!",
  //     ms: "Sertai pasukan kami untuk membina aplikasi Lumi News untuk jutaan rakyat Malaysia!",
  //     zh: "与我们合作，为数百万马来西亚人打造和发展 Lumi News 应用程序!",
  //   },
  //   heroImage: "/subdomain/jobpost/flutter-app-dev.jpg",
  //   seoImage: "/subdomain/jobpost/app-dev-seoimage.png",
  //   position: "Flutter-App-Dev",
  //   categories: [
  //     {
  //       key: "tech",
  //       name: <Trans>👨🏻‍💻 Tech</Trans>,
  //     },
  //     {
  //       key: "full-time",
  //       name: <Trans>🕦 Full-time</Trans>,
  //     },
  //   ],
  //   role: {
  //     position: <Trans>Flutter App Developer</Trans>,
  //     salary: <Trans>Negotiable based on experience</Trans>,
  //     location: <Trans>Bangsar, Kuala Lumpur</Trans>,
  //     workinghours: (
  //       <Trans>Mondays-Wednesday (office); Thursdays-Fridays (remote)</Trans>
  //     ),
  //   },
  //   todos: (
  //     <>
  //       <p>
  //         <Trans>
  //           Join forces with our team to build and grow the Lumi News app for
  //           millions of Malaysians! 💪
  //         </Trans>
  //       </p>
  //       <br />
  //       <ul className="list-disc">
  //         <li>
  //           <Trans>
  //             Develop, analyse, and maintain the Lumi News mobile app
  //           </Trans>
  //         </li>
  //         <li>
  //           <Trans>Design highly scalable, testable code</Trans>
  //         </li>
  //         <li>
  //           <Trans>
  //             Identify bottlenecks and bugs, and devise solutions to these
  //             problems
  //           </Trans>
  //         </li>
  //         <li>
  //           <Trans>Participate in user growth initiatives</Trans>
  //         </li>
  //       </ul>
  //     </>
  //   ),
  //   requirement: (
  //     <ul className="list-disc">
  //       <li>
  //         <Trans>
  //           At least 2 years of experience developing and delivering
  //           Flutter-based apps
  //         </Trans>
  //       </li>
  //       <li>
  //         <Trans>
  //           Good understanding of state management, Flutter flavors and app
  //           architecture
  //         </Trans>
  //       </li>
  //       <li>
  //         <Trans>
  //           Strong communications and consultative skills. Self-initiated and
  //           proactive
  //         </Trans>
  //       </li>
  //       <li>
  //         <Trans>Good experience in version control (Git)</Trans>
  //       </li>
  //       <li>
  //         <Trans>Understands native iOS/Android</Trans>
  //       </li>
  //       <li>
  //         <Trans>
  //           Experience in app deployment (Google Play Store, App Store, Huawei
  //           App Gallery)
  //         </Trans>
  //       </li>
  //       <li>
  //         <Trans>Nice to haves: Firebase, GraphQL</Trans>
  //       </li>
  //       <li>
  //         <Trans>
  //           We invite you to apply even if you don't meet all the requirements
  //         </Trans>
  //       </li>
  //     </ul>
  //   ),
  //   nonTechRequirement: (
  //     <ul className="list-disc">
  //       <li>
  //         <Trans>
  //           You must be hungry to grow a mobile news app for millions of
  //           Malaysians
  //         </Trans>
  //       </li>
  //       <li>
  //         <Trans>
  //           You must be a problem-solver with a great work ethic; resourceful,
  //           disciplined, and would love to join a small team of simple, fun,
  //           practical people based in KL (and Discord)!
  //         </Trans>
  //       </li>
  //     </ul>
  //   ),
  //   team: (
  //     <ul className="list-disc">
  //       <li>
  //         <Trans>
  //           You'll be working together with our in-house app developer and our
  //           tech team
  //         </Trans>
  //       </li>
  //       <li>
  //         <Trans>
  //           You'll also be working closely with our Product Manager and other
  //           team members in tasks that require a collaborative effort
  //         </Trans>
  //       </li>
  //     </ul>
  //   ),
  //   application: (
  //     <Trans>
  //       <p className="font-sen">
  //         Email your CV and GitHub link to&nbsp;
  //         <a href="mailto: work@luminews.my" className="text-primary underline">
  //           work@luminews.my&nbsp;
  //         </a>
  //         and tell us why we should hire you!
  //       </p>
  //     </Trans>
  //   ),
  // },
  // {
  //   label: <Trans>Tech</Trans>,
  //   title: {
  //     en: "Backend Developer",
  //     ms: "Backend Developer",
  //     zh: "Backend Developer",
  //   },
  //   seoDescription: {
  //     en: "Join our tech team to grow the Lumi News app for millions of Malaysians!",
  //     ms: "Sertai pasukan kami untuk membina aplikasi Lumi News untuk jutaan rakyat Malaysia!",
  //     zh: "与我们合作，为数百万马来西亚人打造和发展 Lumi News 应用程序!",
  //   },
  //   heroImage: "/subdomain/jobpost/marketing-lead-cover.jpg",
  //   heroImageLarge: "/subdomain/jobpost/marketing-lead-cover-large.jpg",
  //   seoImage: "https://luminews.my/subdomain/jobpost/backend-dev-seoimage.png",
  //   position: "backend-developer",
  //   categories: [
  //     {
  //       key: "tech",
  //       name: <Trans>👨🏻‍💻 Tech</Trans>,
  //     },
  //     {
  //       key: "full-time",
  //       name: <Trans>🕦 Full-time</Trans>,
  //     },
  //   ],
  //   role: {
  //     position: <Trans>Mid/Senior Backend Developer</Trans>,
  //     salary: <Trans>Negotiable based on experience</Trans>,
  //     location: <Trans>Bangsar, Kuala Lumpur</Trans>,
  //     workinghours: (
  //       <Trans>Mondays-Wednesday (office); Thursdays-Fridays (remote)</Trans>
  //     ),
  //   },
  //   todos: (
  //     <div>
  //       <p>
  //         <Trans>
  //           Join forces with our team to build and grow the Lumi News app for
  //           millions of Malaysians! 💪
  //         </Trans>
  //       </p>
  //       <br />
  //       <ul className="list-disc">
  //         <li>
  //           <Trans>Develop and maintain Lumi News' backend application</Trans>
  //         </li>
  //         <li>
  //           <Trans>Design highly scalable, testable code</Trans>
  //         </li>
  //         <li>
  //           <Trans>
  //             Identify bottlenecks and bugs, and devise solutions to these
  //             problems
  //           </Trans>
  //         </li>
  //         <li>
  //           <Trans>Participate in user growth initiatives</Trans>
  //         </li>
  //       </ul>
  //     </div>
  //   ),
  //   requirement: (
  //     <ul className="list-disc">
  //       <li>
  //         <Trans>
  //           Over 3 years of working experience in software engineering/web
  //           development
  //         </Trans>
  //       </li>
  //       <li>
  //         <Trans>
  //           A strong grasp of relational databases (we use PostgreSQL)
  //         </Trans>
  //       </li>
  //       <li>
  //         <Trans>Experience/exposure in building API using REST/GraphQL</Trans>
  //       </li>
  //       <li>
  //         <Trans>Cloud services such as AWS/GCP</Trans>
  //       </li>
  //       <li>
  //         <Trans>Automated testing (Rspec/Minitest) and CI/CD</Trans>
  //       </li>
  //       <li>
  //         <Trans>Good experience in version control (Git)</Trans>
  //       </li>
  //       <li>
  //         <Trans>
  //           Good to have: Experience in background job processing (Sidekiq or
  //           similar)
  //         </Trans>
  //       </li>
  //       <li>
  //         <Trans>Skills in web scraping is a plus!</Trans>
  //       </li>
  //       <li>
  //         <Trans>
  //           We invite you to apply even if you don't meet all the requirements
  //         </Trans>
  //       </li>
  //     </ul>
  //   ),
  //   nonTechRequirement: (
  //     <ul className="list-disc">
  //       <li>
  //         <Trans>
  //           You must be hungry to grow a mobile news app for millions of
  //           Malaysians
  //         </Trans>
  //       </li>
  //       <li>
  //         <Trans>
  //           You must be a problem-solver with a great work ethic; resourceful,
  //           disciplined, and would love to join a small team of simple, fun,
  //           practical people based in KL (and Discord)!
  //         </Trans>
  //       </li>
  //     </ul>
  //   ),
  //   team: (
  //     <ul className="list-disc">
  //       <li>
  //         <Trans>
  //           You'll be working together with our senior backend developer and our
  //           tech team
  //         </Trans>
  //       </li>
  //       <li>
  //         <Trans>
  //           You'll also be working closely with our Product Manager and other
  //           team members in tasks that require a collaborative effort
  //         </Trans>
  //       </li>
  //     </ul>
  //   ),
  //   application: (
  //     <Trans>
  //       <p className="font-sen">
  //         Email your CV and GitHub link to&nbsp;
  //         <a href="mailto: work@luminews.my" className="text-primary underline">
  //           work@luminews.my&nbsp;
  //         </a>
  //         and tell us why we should hire you!
  //       </p>
  //     </Trans>
  //   ),
  // },
];
